<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-04 09:21:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-15 10:54:39
 * @Description: 鲸鱼优选 Banner
 -->

<template>
  <div class="banner-wrapper">
    <div class="content">
      <img src="https://files.jinr.com/jinr-index/img/jinr-banner.png" alt="" srcset="" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'banner'
};
</script>
<style lang="less" scoped>
.banner-wrapper {
  position: relative;
  overflow: hidden;
  .content {
    width: 1200px;
    height: 400px;
    margin: 0 auto;
    position: relative;
  }
  img {
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
